/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const LoanHistoryDetails = lazyLoad(
  () => import('./index'),
  module => module.LoanHistoryDetails,
);
